<template lang="">
    <div>
        <button class="btn btn-outline-success btn-lg" @click="showUserInfoForm" title="匯出表單">匯出表單</button>

        <modal ref="userInfoForm" name="匯出表單">
            <template>
                <form @submit.prevent="submitForm">
                    <div class="form-group">
                        <label for="setExportDate">選擇訂單日期</label>
                        <input type="date" name="setExportDate" id="setExportDate" class="w-100 tags" v-model="paymentDate" required>
                    </div>
                    <div class="form-group">
                        <label for="paymentStatus">訂單狀態</label>
                        <div class="w-50 tags row ml-5">
                            <div class="col-6">
                                <input type="radio" id="paid" value="paid" v-model="paymentStatus" required><label for="paid">完成交易</label>
                            </div>
                            <div class="col-6">
                                <input type="radio" id="unpaid" value="unpaid" v-model="paymentStatus" required><label for="unpaid">尚未付款</label>
                            </div>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-success">匯出</button>
                </form>
            </template>
        </modal>
    </div>
</template>

<script>
import ApiBase from './components/ApiBase';

export default {
    extends: ApiBase,
    data() {
        return {
            base_url,
            paymentStatus: '',
            paymentDate: '',
        }
    },
    mounted() {
    },
    methods: {
        showUserInfoForm() {
            this.$refs.userInfoForm.modalShow();
        },
        submitForm() {
            window.location.href = base_url + '/admin/export/order?date=' + this.paymentDate + '&status=' + this.paymentStatus;
            this.$refs.userInfoForm.modalHide();
        }
    }
}
</script>
<style scoped>
.user-info-btn {
    border-color: #7a8473;
    color: #f9f9f9;
    border-radius: 50%;
    padding: 1.25em 1em;
    background-color: #7a8473;
}

.user-info-btn:hover {
    background-color: #f9f9f9;
    color: #7a8473;
}
</style>
